module.exports = __webpack_public_path__ + "static/img/zhifubao.05e55ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhifubao.png
// module id = 22/f
// module chunks = 0